import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Footer = () => {

  const navigate = useNavigate();

  return (
      <footer className="text-neutral-300 py-12" style={{backgroundColor: '#000'}} >
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <Link to="/" className="flex items-center gap-2 no-underline">
                  <img 
                    src="logo-white.jpg" 
                    alt="CrokChef Logo" 
                    className="logo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.innerHTML = `
                        <span style="color: var(--primary-color); font-size: 24px;">🍔</span>
                      `;
                    }}
                  />
                </Link>
              </div>
              <p className="text-sm text-neutral-400">Las mejores hamburguesas y pollo frito, directo a tu puerta.</p>
            </div>
            <div>
              <h3 className="text-white font-bold mb-4 uppercase tracking-wider">Navegación</h3>
              <ul className="space-y-2 text-sm">
                <li><a href="#menu" className="hover:text-[var(--secondary-color)] transition-colors no-underline" style={{ color: '#c7c7cc' }}>Ver Menú</a></li>
                <li><button onClick={() => document.getElementById('nosotros')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-[var(--secondary-color)] transition-colors cursor-pointer bg-transparent border-none text-sm text-left" style={{ color: '#c7c7cc' }}>Nosotros</button></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-bold mb-4 uppercase tracking-wider">Legal</h3>
              <ul className="space-y-2 text-sm">
                <li><button className="hover:text-[var(--secondary-color)] transition-colors cursor-pointer bg-transparent border-none text-sm text-left" style={{ color: '#c7c7cc' }} onClick={() => navigate('/politica-privacidad')}>Privacidad</button></li>
                <li><button className="hover:text-[var(--secondary-color)] transition-colors cursor-pointer bg-transparent border-none text-sm text-left" style={{ color: '#c7c7cc' }} onClick={() => alert('Términos de servicio')}>Términos de servicio</button></li>
              </ul>
            </div>
            <div>
              <h3 className="text-white font-bold mb-4 uppercase tracking-wider">Síguenos</h3>
              <div className="flex gap-4">
                <button 
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-colors hover:bg-[var(--primary-color)] hover:text-white" 
                  style={{ backgroundColor: '#2a2a3e' }}
                  onClick={() => window.open('https://instagram.com', '_blank')}
                  aria-label="Instagram"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="18" height="18">
                    <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                  </svg>
                </button>
                <button 
                  className="w-10 h-10 rounded-full flex items-center justify-center transition-colors hover:bg-[var(--primary-color)] hover:text-white" 
                  style={{ backgroundColor: '#2a2a3e' }}
                  onClick={() => window.open('https://facebook.com', '_blank')}
                  aria-label="Facebook"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="18" height="18">
                    <path fill="currentColor" d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="mt-12 border-t pt-8 text-center text-sm" style={{ borderColor: '#2a2a3e', color: 'var(--text-muted)' }}>
            © 2026 CrokChef. Todos los derechos reservados.
          </div>
        </div>
      </footer>

  );
};

const styles = {
  footer: {
    backgroundColor: '#1a1a2e',
    color: 'white',
    padding: '30px 50px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  socialLinks: {
    display: 'flex',
    gap: '20px',
  },
};

export default Footer;